import { Box, Stack, LoadingOverlay } from "@mantine/core";
import _ from "lodash";

import { BigRangeBar } from "components/BigRangeBar";
import { SinglePointRangeBarWithFlag } from "components/DetailedRangeBar";
import { ExplorerNoResults } from "components/ExplorerNoResults";
import { useSelectedPercentile } from "components/SelectedPercentileProvider";
import { useIsLoadingSearchData } from "hooks/routing";
import { StatsSummary } from "services/PostsService";

interface MarketRangeCardProps {
  percentiles: StatsSummary["percentiles"];
}

export function MarketRangeCard({ percentiles }: MarketRangeCardProps): JSX.Element {
  const { selectedPercentile } = useSelectedPercentile();
  const loading = useIsLoadingSearchData();
  const percentileData = percentiles[selectedPercentile as keyof StatsSummary["percentiles"]];
  const noData = _.isNil(percentileData.salaryLow) || _.isNil(percentileData.salaryHigh);
  const isSinglePoint = percentileData.salaryLow === percentileData.salaryHigh;

  return (
    <Box
      pos="relative"
      pt={{ base: 0, md: 16 }}
      sx={{
        "@media(max-width: var(--mantine-breakpoint-sm))": {
          borderLeft: 0,
          borderRight: 0,
          borderRadius: 0,
          borderBottom: 0,
        },
      }}
    >
      <Stack align="stretch">
        <LoadingOverlay
          visible={loading}
          overlayProps={{
            blur: 1,
          }}
        />
        {/* <Tooltip
          withinPortal
          multiline
          label="The average salary range based on the filters selected below. Our data is sourced from the salary ranges disclosed by companies in their job posts, as required by new pay transparency laws."
          transition="fade"
          transitionDuration={150}
          events={{
            hover: true,
            focus: true,
            touch: true,
          }}
          sx={{
            backgroundColor: "black",
            maxWidth: 420,
            padding: "8px 12px",
            color: "white",
          }}
        >
          <Group justify="center">
            <Eyebrow sx={{ letterSpacing: "inherit" }}>Market range</Eyebrow>
            <Info
              size={14}
              style={{ transform: "translateY(-1px)" }}
            />
          </Group>
        </Tooltip> */}
        <Box px={{ base: 8, xs: 16 }} pt={16} pb={{ base: 0, md: 24 }}>
          {noData ? (
            <ExplorerNoResults />
          ) : (
            <Stack gap={16}>
              <Box pos="relative">
                <Box mx={{ base: 0, xs: 8 }}>
                  {isSinglePoint ? (
                    <SinglePointRangeBarWithFlag value={percentileData.salaryLow!} />
                  ) : (
                    <BigRangeBar
                      rangeMin={percentileData.salaryLow!}
                      rangeLow={percentileData.salaryLow!}
                      rangeHigh={percentileData.salaryHigh!}
                      rangeMax={percentileData.salaryHigh!}
                    />
                  )}
                </Box>
              </Box>
            </Stack>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
